<template>
    <NavbarMain />

    <PresentationAnnouncements :photo="first_section_image_en" :title="first_section_title_en"
        :content="first_section_content_en" :content-link="second_section_button_content_en" :link-x="second_section_button_link_en" />

    <WidePhotoComponent :photo="third_section_image_en" :content="third_section_content_en" />

    <FooterPage />
</template>

<script>
import axios from 'axios';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';
import PresentationAnnouncements from '@/components/PresentationAnnouncements.vue';

export default {
    components: {
        NavbarMain,
        FooterPage,
        WidePhotoComponent,
        PresentationAnnouncements
    },
    data() {
        return {
            announcementData: { items_en: [{}] },
            first_section_image_en: '',
            first_section_title_en: '',
            first_section_content_en: '',
            second_section_title_en: '',
            second_section_button_content_en: '',
            second_section_button_link_en: '',
            third_section_image_en: '',
            third_section_content_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/announcements-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.announcementData = response.data || { items_en: [] };

                if (this.announcementData.items_en[0]?.active === true) {
                    this.first_section_title_en = this.announcementData.items_en[0].first_section_title;
                    this.first_section_content_en = this.announcementData.items_en[0].first_section_content;
                    this.first_section_image_en = this.announcementData.items_en[0].first_section_image;
                    this.second_section_title_en = this.announcementData.items_en[0].second_section_button_title;
                    this.second_section_button_content_en = this.announcementData.items_en[0].second_section_button_content;
                    this.second_section_button_link_en = this.announcementData.items_en[0].second_section_button_link;
                    this.third_section_image_en = this.announcementData.items_en[0].third_section_image;
                    this.third_section_content_en = this.announcementData.items_en[0].third_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching Announcements data:', error);
            });
    }
}
</script>

<style>
.columns-4-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding-left: 3rem;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>
